/* quantity-break-table.js
USED BY: quantity-pricing-table.liquid

PURPOSE: calcuates % discount, extended price for price break table and
highlights active pricing row based on quantity input
*/

// initialize prices for each qty break
    let price0 = "$0.00";
    let price1 = "$0.00";
    let price2 = "$0.00";
    let price3 = "$0.00";
    let price4 = "$0.00";
    let price5 = "$0.00";
    let price6 = "$0.00";
    let price7 = "$0.00"; 
    let quantity = 7;
    let qty = 7;

// get all of the price break rows
let allRows = document.querySelectorAll('.qtyBreak'); 
// get the input field for quantity
const qtyInput = document.querySelector('.qty-input__input');
// get the quantity (+) and (-) buttons so we can listen for them
const qtyButtons = document.querySelectorAll('.qty-input__btn');

// populate everything on first page load
window.addEventListener("load", (event) => {
    // get all rows in the quantity price break table
    getQtyPrices();
    setDiscount(allRows);
    setPriceQty(quantity);    
});


// // add event listener for change in quantity
// qtyInput.addEventListener('input', (event) => {
//     quantity = qtyInput.value; 
//     setQtyBreakTableRow(quantity);
//     setPriceQty(quantity);
// })


// add event listener for (-) quantity button
qtyButtons[0].addEventListener('click', function decreaseQty(){
    quantity=parseInt(qtyInput.value)-1;
    if (quantity <= 6){
      quantity = 7;
    }
    setQtyBreakTableRow(quantity);
    setPriceQty(quantity);
});
// add event listener for (+) quantity button
qtyButtons[1].addEventListener('click', function increaseQty(){
    quantity=parseInt(qtyInput.value)+1; 
    setQtyBreakTableRow(quantity);
    setPriceQty(quantity);
});
// add event listener(s) for change in manual quantity input (typed in value)
qtyInput.addEventListener('input', function qtyUpdate(){
    quantity = qtyInput.value; 
    setQtyBreakTableRow(quantity);
    setPriceQty(quantity);
});

function setPriceQty(qty){
    // set price underneath qty break table
    // Function to format the price above to USD using the locale, style, and currency.
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    const priceLabel = document.querySelector('.PriceOfQty');
   if (qty <= 9) {
        priceLabel.innerHTML = USDollar.format(price0)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price0) +")";
    } else if (qty <= 24) {
        priceLabel.innerHTML = USDollar.format(price1)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price1) +")";
    } else if (qty <= 49) {
        priceLabel.innerHTML = USDollar.format(price2)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price2) +")";
    } else if (qty <= 99) {
        priceLabel.innerHTML = USDollar.format(price3)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price3) +")";
    } else if (qty <= 249) {
        priceLabel.innerHTML = USDollar.format(price4)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price4) +")";
    } else if (qty <= 499) {
        priceLabel.innerHTML = USDollar.format(price5)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price5) +")";
    } else if (qty <= 999) {
        priceLabel.innerHTML = USDollar.format(price6)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price6) +")";
    } else {
        priceLabel.innerHTML = USDollar.format(price7)+ "ea   ("+qty+" pieces: "+ USDollar.format(qty*price7) +")";
    }
}



// highlight the appropriate row in the quantity price break table 
function setQtyBreakTableRow(qty) {
  // const allRows = document.querySelectorAll('.qtyBreak'); 
  // const qtyInput = document.querySelector('.qty-input__input');
    let qtyBreakLevel = 0;
    clearRows(allRows);

    if (qty <= 9) {
        qtyBreakLevel = 0;
    } else if (qty <= 24) {
        qtyBreakLevel = 1;
    } else if (qty <= 49) {
        qtyBreakLevel = 2;
    } else if (qty <= 99) {
        qtyBreakLevel = 3;
    } else if (qty <= 249) {
        qtyBreakLevel = 4;
    } else if (qty <= 499) {
        qtyBreakLevel = 5;
    } else if (qty <= 999) {
        qtyBreakLevel = 6;
    } else {
        qtyBreakLevel = 7;
    }
    // get all rows in the quantity price break table
    //const allRows = document.querySelectorAll('.qtyBreak');
    // appends the row's class list with the highlight class
    allRows[qtyBreakLevel].classList.add("row-active");
  
}

// clear all highglights prior to evaluating quantity (prevents two or more rows from being highlighted at the same time)
function clearRows(allRows) {
    for (let eachRow of allRows) {
        eachRow.classList.remove("row-active")
    }
}


// get prices for each qty break from table
function getQtyPrices(){
    price0 = document.querySelector('#p0').innerHTML;
    price1 = document.querySelector('#p1').innerHTML;
    price2 = document.querySelector('#p2').innerHTML;
    price3 = document.querySelector('#p3').innerHTML;
    price4 = document.querySelector('#p4').innerHTML;
    price5 = document.querySelector('#p5').innerHTML;
    price6 = document.querySelector('#p6').innerHTML;
    price7 = document.querySelector('#p7').innerHTML; 
   /*  let price0 = document.querySelector('#p0').innerHTML;
    let price1 = document.querySelector('#p1').innerHTML;
    let price2 = document.querySelector('#p2').innerHTML;
    let price3 = document.querySelector('#p3').innerHTML;
    let price4 = document.querySelector('#p4').innerHTML;
    let price5 = document.querySelector('#p5').innerHTML;
    let price6 = document.querySelector('#p6').innerHTML;
    let price7 = document.querySelector('#p7').innerHTML;  */
}

// populate the discount % column
function setDiscount(allRows) {

    // remove the dollar sign so we can use as a number
    price0 = parseFloat(price0.replace(/[$,]+/g,""));
    price1 = parseFloat(price1.replace(/[$,]+/g,""));
    price2 = parseFloat(price2.replace(/[$,]+/g,""));
    price3 = parseFloat(price3.replace(/[$,]+/g,""));
    price4 = parseFloat(price4.replace(/[$,]+/g,""));
    price5 = parseFloat(price5.replace(/[$,]+/g,""));
    price6 = parseFloat(price6.replace(/[$,]+/g,""));
    price7 = parseFloat(price7.replace(/[$,]+/g,""));
   /* price0 = price0.slice(1);
    price1 = price1.slice(1);
    price2 = price2.slice(1);
    price3 = price3.slice(1);
    price4 = price4.slice(1);
    price5 = price5.slice(1);
    price6 = price6.slice(1);
    price7 = price7.slice(1);*/

    // calculate discount %
    let discount1 = Math.round((price0 - price1) / price0 * 100) + "%";
    let discount2 = Math.round((price0 - price2) / price0 * 100) + "%";
    let discount3 = Math.round((price0 - price3) / price0 * 100) + "%";
    let discount4 = Math.round((price0 - price4) / price0 * 100) + "%";
    let discount5 = Math.round((price0 - price5) / price0 * 100) + "%";
    let discount6 = Math.round((price0 - price6) / price0 * 100) + "%";
    let discount7 = Math.round((price0 - price7) / price0 * 100) + "%";

    // update the discount cells in the table
    document.querySelector('#d0').innerHTML = '--';
    document.querySelector('#d1').innerHTML = discount1;
    document.querySelector('#d2').innerHTML = discount2;
    document.querySelector('#d3').innerHTML = discount3;
    document.querySelector('#d4').innerHTML = discount4;
    document.querySelector('#d5').innerHTML = discount5;
    document.querySelector('#d6').innerHTML = discount6;
    document.querySelector('#d7').innerHTML = discount7;

    // Function to format the price above to USD using the locale, style, and currency.
    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // calculated the extended prices
    let extended0 = price0;
    let extended1 = price1 * 10;
    let extended2 = price2 * 25;
    let extended3 = price3 * 50;
    let extended4 = price4 * 100;
    let extended5 = price5 * 250;
    let extended6 = price6 * 500;
    let extended7 = price7 * 1000;

    // format the extended price values as US dollars and place values in the appropriate cells
    document.querySelector('#ext0').innerHTML = USDollar.format(price0);
    document.querySelector('#ext1').innerHTML = USDollar.format(extended1);
    document.querySelector('#ext2').innerHTML = USDollar.format(extended2);
    document.querySelector('#ext3').innerHTML = USDollar.format(extended3);
    document.querySelector('#ext4').innerHTML = USDollar.format(extended4);
    document.querySelector('#ext5').innerHTML = USDollar.format(extended5);
    document.querySelector('#ext6').innerHTML = USDollar.format(extended6);
    document.querySelector('#ext7').innerHTML = USDollar.format(extended7);
}


